import { render } from "./FooterApp.vue?vue&type=template&id=f0ba9778&scoped=true"
import script from "./FooterApp.vue?vue&type=script&lang=js"
export * from "./FooterApp.vue?vue&type=script&lang=js"

import "./FooterApp.vue?vue&type=style&index=0&id=f0ba9778&scoped=true&lang=scss"

import exportComponent from "C:\\projets\\rivha\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0ba9778"]])

export default __exports__